import { X, Globe2 } from "lucide-react";

export function HBMShareReviewModal({ open, situation, busy, onClose, onConfirm }) {
  if (!open || !situation) return null;
  return (
    <div className="hbm-share-backdrop" data-testid="anonymize-modal-container" role="dialog" aria-modal="true">
      <section className="hbm-share-modal">
        <header>
          <div>
            <span>REVIEW BEFORE SHARING</span>
            <h2>Public situation narrative</h2>
          </div>
          <button type="button" onClick={onClose} data-testid="anonymize-modal-close-button" aria-label="Close review">
            <X size={18} />
          </button>
        </header>
        <div className="hbm-share-preview" data-testid="anonymize-narrative-preview">
          {situation.anonymized_body || situation.body}
        </div>
        <p>
          Only this narrative is shared into the situation feed. Your private reasoning thread
          and personal context stay hidden.
        </p>
        <footer>
          <button type="button" onClick={onClose} disabled={busy} data-testid="anonymize-modal-cancel-button">Keep private</button>
          <button type="button" onClick={onConfirm} disabled={busy} data-testid="anonymize-confirm-publish-btn">
            <Globe2 size={15} /> Share as Situation
          </button>
        </footer>
      </section>
    </div>
  );
}